import styled from 'styled-components';
import ImgSuccess from '../../../../../assets/media/aden/ticket-success.png';

const PopUpSuccess = (props) => {
    const { setOpenModal, actionSucces, resetData } = props;
    return (
        <Modal>
            <img src={ImgSuccess} alt="success" />
            <h3>
                ¡El anuncio se <br /> {`${actionSucces} `} exitosamente!
            </h3>
            <button
                onClick={() => {
                    setOpenModal(false);
                    resetData();
                }}
            >
                Actualizar
            </button>
        </Modal>
    );
};

export default PopUpSuccess;

const Modal = styled.div`
    position: fixed;
    width: 450px;
    height: 450px;
    top: 50%;
    left: 50%;
    transform: translate(-50.1%, -50.1%);
    background-color: #fff;
    z-index: 99;
    box-shadow: 0px 12px 24px -15px #0000001a, 0px 0px 10px -6px #00000040;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    h3 {
        text-align: center;
    }

    button {
        cursor: pointer;
        width: 80%;
        height: 40px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background-color: #cd2118;

        :hover {
            background-color: #b31d15;
        }
    }
`;
